/** Shared integration copy and app-connection blocks for NexusB2B demos. */

export const NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME = 'Salesforce CRM Integration — README.md'
